import axios from "axios";
import { REACT_APP_BASE_PATH } from "../config/runtimeConfig";
import type { ClientBranding } from "../types/clientBranding";

const publicApi = axios.create({
  baseURL: REACT_APP_BASE_PATH,
  headers: { "Content-Type": "application/json" },
});

export const clientBrandingService = {
  getBranding: async (): Promise<ClientBranding> => {
    const res = await publicApi.get<ClientBranding>("/public/config/branding");
    return res.data;
  },
};
